import React from 'react';
import MetaField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { Collapse } from '@mui/material';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';

function PersonalRetirementAccountLayout({ classes }) {
  const { resource } = useMetaLayoutContext();
  const noBeneficiary = resource.attr('hasBeneficiary') === 'false';

  return (
    <div className={classes.root}>
      <MetaField attr="ownerClientId" className={classes.alignLeft} />
      <div className={classes.row}>
        <MetaField attr={'currentYearContributions'} />
        <MetaField attr={'currentYearContributionsAsOf'} />
      </div>
      <div className={classes.row}>
        <MetaField
          attr="facetModel"
          hidden={resource.attr('isManaged') === 'false'}
        />
        <MetaField
          attr="allocationType"
          hidden={resource.attr('isManaged') === 'false'}
        />
      </div>
      <div className={classes.row}>
        <MetaField attr="employeeAdditions" />
        <MetaField attr="employerAdditions" />
      </div>
      <MetaField attr="currentEmployer" />
      <MetaField attr="active" />
      <MetaField attr="shares" />
      <MetaField attr="hasBeneficiary" />
      <Collapse in={!noBeneficiary}>
        <Box>
          <MetaField attr="primaryBeneficiary" hidden={noBeneficiary} />
          <MetaField attr="contingentBeneficiary" hidden={noBeneficiary} />
        </Box>
      </Collapse>
    </div>
  );
}

PersonalRetirementAccountLayout.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles({
  root: {},
  control: {
    margin: 0,
  },
  row: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '12px',
  },
  alignLeft: {
    textAlign: 'left',
  },
})(PersonalRetirementAccountLayout);
